"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var StyleTileV2_1 = __importDefault(require("DreamCoat/SavedStyle/StyleTileV2/StyleTileV2"));
exports.default = (function (mountReactComponent, di) {
    var brandStore = di.get("brandStore");
    return function (style) {
        return mountReactComponent(react_1.default.createElement(StyleTileV2_1.default, { style: style, size: "large", colors: brandStore.allColors }));
    };
});
